module.exports = __webpack_public_path__ + "img/total-request.40749020.svg";